import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=230b16b6&scoped=true"
import script from "./ContentBox.vue?vue&type=script&lang=js"
export * from "./ContentBox.vue?vue&type=script&lang=js"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=230b16b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b16b6",
  null
  
)

export default component.exports